var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection"},[_c('van-uploader',{attrs:{"multiple":"","after-read":_vm.afterRead,"accept":"image/*,.pdf,.zip,.doc,.docx,.ppt,.txt,.xls,.xlsx,.ofd"}},[_vm._t("gather")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }